class ProductHeatingSystem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initContentHeight();
    // 添加 resize 事件监听器
    this.resizeListener = this.debounce(this.initContentHeight.bind(this), 200);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectedCallback() {
    // 移除 resize 事件监听器
    window.removeEventListener('resize', this.resizeListener);
  }

  initContentHeight() {
    let windowWidth = window.innerWidth;
    if (windowWidth > 750) {
      let height = 0;
      $('.heating-content').each(function () {
        if (height < $(this).height()) {
          height = $(this).height();
        }
      });
      $('.heating-content').css('min-height', `${height}px`);
    } else {
      $('.heating-content').css('min-height', `unset`);
    }
  };

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// 注册自定义元素
customElements.define("product-heating-system", ProductHeatingSystem);